import { getLang } from "helpers/themeHelpers";

export const linkToSupport = () => {
    const locale = getLang();
    return `/${locale}/${locale === "ar" ? "مساعدة" : "support"}`;
};
